import { render, staticRenderFns } from "./TurmaExpansionItem.vue?vue&type=template&id=8c6112ec&scoped=true"
import script from "./TurmaExpansionItem.vue?vue&type=script&lang=js"
export * from "./TurmaExpansionItem.vue?vue&type=script&lang=js"
import style0 from "./TurmaExpansionItem.vue?vue&type=style&index=0&id=8c6112ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6112ec",
  null
  
)

export default component.exports